import React from 'react'
import PropTypes from 'prop-types'

import Api from '../../Api.js'

import TripCard from './TripCard'

import './styles.less'


class FligthsTable extends React.Component {

	componentWillMount() {
		this.setState({loading:false, trips:[]})
	}
	componentDidMount() {
		this.setState({loading:false, trips:[]})
	}

	componentDidUpdate(prev_props) {
		if (prev_props.day !== this.props.day) {	
			this.setState({loading:true, trips:[]})
			Api.getTrips(this.props.day, (trips)=>{
				this.setState({trips:trips})
				setTimeout(()=>{
					this.setState({loading:false})				
				},10)
			})
		}
	}

	render() {
		const loading = this.state.loading ? 'loading':'loaded'

		return (
			<div className={`fligths  ${loading}`}>
				
				{this.state.trips.map((trip, i)=>{
					return <TripCard trip={trip} key={i} />
				})}

			</div>
		)
	}
}

FligthsTable.propTypes = {
	day: PropTypes.number,
}

export default FligthsTable


// WEBPACK FOOTER //
// ./src/components/FligthsTable/index.js